import { Component, Input } from '@angular/core';
import {
    PlatformService, LoggingService, TokenService, LocalStorageService,
    NotificationsService, PriceService, AccountService, TeamEvent,
    SiteLayout
} from '@varsity/services';
import { BaseComponent } from '@varsity/components';
import { PopoverController, ToastController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the PackageInfoComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'package-info',
  templateUrl: 'package-info.html'
})
export class PackageInfoComponent extends BaseComponent {

    @Input() public packageInfo: any | null;
    @Input() public viewType: string;
    teamLogoPath: string;

    constructor(
        protected platformService: PlatformService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected priceService: PriceService,
        protected popoverCtrl: PopoverController,
        protected toastCtrl: ToastController,
        protected accountService: AccountService,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "PackageInfoComponent"
        );
    }

    ngOnInit() {
        super.ngOnInit();

        if (this.notificationsService.sitelayout) {
            this.configureImages(this.notificationsService.sitelayout);
        }

        this.notificationsService.sitelayout$
            .takeUntil(this.componentDestroyed$)
            .subscribe((value) => {
                this.configureImages(value);
            })
        
    }

    configureImages(value: SiteLayout) {
        let event = this.packageInfo as TeamEvent;
        if (event.sitelayout && event.sitelayout.TeamLogo) {
            this.teamLogoPath = this.basePath + event.sitelayout.TeamLogo;
        } else {
            this.teamLogoPath = this.basePath + value.TeamLogo;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/package-info/package-info.ts